(() => {
  "use strict";

  document.documentElement.classList.remove("no-js");

  const focusable = "a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex='-1'])";
  let activeDrawer = null;
  let drawerTrigger = null;

  const closeDrawer = () => {
    if (!activeDrawer) return;
    activeDrawer.hidden = true;
    activeDrawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("dialog-open");
    drawerTrigger?.setAttribute("aria-expanded", "false");
    drawerTrigger?.focus();
    activeDrawer = null;
    drawerTrigger = null;
  };

  const openDrawer = trigger => {
    const drawer = document.getElementById(trigger.dataset.drawerOpen);
    const dialog = drawer?.querySelector("[role='dialog']");
    if (!drawer || !dialog) return;
    activeDrawer = drawer;
    drawerTrigger = trigger;
    drawer.hidden = false;
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("dialog-open");
    trigger.setAttribute("aria-expanded", "true");
    dialog.querySelector(focusable)?.focus();
  };

  document.addEventListener("click", event => {
    const opener = event.target.closest("[data-drawer-open]");
    if (opener) openDrawer(opener);
    if (event.target.closest("[data-drawer-close]")) closeDrawer();
  });

  document.addEventListener("keydown", event => {
    if (!activeDrawer) return;
    if (event.key === "Escape") return closeDrawer();
    if (event.key !== "Tab") return;
    const dialog = activeDrawer.querySelector("[role='dialog']");
    const items = dialog ? [...dialog.querySelectorAll(focusable)].filter(item => item.offsetParent !== null) : [];
    if (!items.length) return event.preventDefault();
    const first = items[0];
    const last = items.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  const closeMegaMenus = except => {
    document.querySelectorAll("[data-mega]").forEach(menu => {
      if (menu === except) return;
      menu.hidden = true;
      document.querySelector(`[data-mega-toggle="${menu.id}"]`)?.setAttribute("aria-expanded", "false");
    });
  };
  document.querySelectorAll("[data-mega-toggle]").forEach(toggle => {
    const menu = document.getElementById(toggle.dataset.megaToggle);
    const group = toggle.closest(".nav-group");
    if (!menu || !group) return;
    const megaLinks = () => [...menu.querySelectorAll("a[href]")];
    let closeTimer;
    const setOpen = open => {
      closeMegaMenus(open ? menu : null);
      menu.hidden = !open;
      toggle.setAttribute("aria-expanded", String(open));
    };
    const open = () => { clearTimeout(closeTimer); setOpen(true); };
    const closeSoon = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => !group.matches(":hover, :focus-within") && setOpen(false), 220);
    };
    toggle.addEventListener("focus", open);
    toggle.addEventListener("keydown", event => {
      if (event.key !== "ArrowDown") return;
      event.preventDefault();
      open();
      megaLinks()[0]?.focus();
    });
    menu.addEventListener("keydown", event => {
      if (!["ArrowDown", "ArrowUp"].includes(event.key)) return;
      const links = megaLinks();
      const current = links.indexOf(document.activeElement);
      if (current < 0) return;
      event.preventDefault();
      const direction = event.key === "ArrowDown" ? 1 : -1;
      links[(current + direction + links.length) % links.length].focus();
    });
    group.addEventListener("mouseenter", () => matchMedia("(hover: hover) and (pointer: fine)").matches && open());
    group.addEventListener("mouseleave", () => matchMedia("(hover: hover) and (pointer: fine)").matches && closeSoon());
    group.addEventListener("focusout", event => !group.contains(event.relatedTarget) && setOpen(false));
    group.addEventListener("keydown", event => {
      if (event.key !== "Escape") return;
      event.preventDefault();
      toggle.focus();
      setOpen(false);
    });
  });
  document.addEventListener("click", event => !event.target.closest(".nav-group") && closeMegaMenus());

  const home = document.querySelector("[data-home-a8]");
  if (home) {
  const journey = home.querySelector("[data-home-journey]");
  const hero = home.querySelector("[data-home-hero]");
  const ambient = home.querySelector(".ambient");
  const crossing = home.querySelector(".crossing");
  const beats = [...home.querySelectorAll("[data-home-beat]")];
  const moodRoot = home.querySelector("[data-home-mood-root]");
  const moodIntro = moodRoot.querySelector(".mood-intro");
  const moodIntroContent = moodRoot.querySelector(".mood-intro__content");
  const moodStage = moodRoot.querySelector("[data-home-mood-stage]");
  const moodTabs = [...moodRoot.querySelectorAll("[data-home-mood]")];
  const moodImages = [...moodRoot.querySelectorAll("[data-home-mood-image]")];
  const moodIndexElement = moodRoot.querySelector(".mood-index");
  const moodCopy = moodRoot.querySelector(".mood-copy");
  const moodSubtitle = moodRoot.querySelector("[data-home-mood-subtitle]");
  const moodLine = moodRoot.querySelector("[data-home-mood-line]");
  const moodDescription = moodRoot.querySelector("[data-home-mood-description]");
  const moodLink = moodRoot.querySelector("[data-home-mood-link]");
  const reduced = matchMedia("(prefers-reduced-motion: reduce)");
  const saveData = navigator.connection?.saveData === true;
  const canHover = matchMedia("(hover: hover) and (pointer: fine)").matches;
  const veilAnchors = [["27%", "46%", "28%"], ["28%", "42%", "28%"], ["29%", "55%", "72%"], ["72%", "50%", "72%"]];
  const beatWindows = [[0, 0, .13, .2], [.15, .2, .35, .42], [.37, .42, .56, .64], [.59, .64, .77, .88]];
  let frameRequested = false;
  let seekPending = false;
  let nextTime = 0;
  let crossingHasFrame = false;
  let crossingRevealStarted = 0;
  let crossingRetries = 0;
  let crossingLoad = false;
  let crossingObjectUrl = "";
  let journeyComplete = false;
  let moodIndex = 0;
  let moodRequest = 0;
  let moodInView = false;
  let moodTimer = 0;
  let moodHovering = false;
  let moodLocked = false;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const smoothstep = (start, end, value) => {
    const position = clamp((value - start) / (end - start), 0, 1);
    return position * position * (3 - (2 * position));
  };
  const beatState = (progress, [enterStart, holdStart, holdEnd, exitEnd]) => {
    if (progress < enterStart || progress > exitEnd) return { opacity: 0, y: 20 };
    if (progress < holdStart) { const opacity = smoothstep(enterStart, holdStart, progress); return { opacity, y: (1 - opacity) * 20 }; }
    if (progress <= holdEnd || holdEnd === exitEnd) return { opacity: 1, y: 0 };
    const exit = smoothstep(holdEnd, exitEnd, progress);
    return { opacity: 1 - exit, y: exit * -12 };
  };
  const crossingFrameDuration = 1 / 24;
  const setCrossingTime = () => {
    if (!crossing.duration || !Number.isFinite(crossing.duration) || seekPending) return;
    if (Math.abs(crossing.currentTime - nextTime) <= (crossingFrameDuration / 2)) return;
    seekPending = true;
    crossing.currentTime = nextTime;
    requestRender();
  };

  const renderJourney = () => {
    frameRequested = false;
    if (reduced.matches) return;
    const rect = journey.getBoundingClientRect();
    if (rect.bottom <= 0 && journeyComplete) return;
    journeyComplete = rect.bottom <= 0;
    const travel = Math.max(1, journey.offsetHeight - innerHeight);
    const progress = clamp(-rect.top / travel, 0, 1);
    const windows = innerWidth <= 600
      ? [[0, 0, .12, .17], [.17, .21, .34, .39], [.39, .43, .55, .6], [.6, .64, .77, .88]]
      : beatWindows;
    const states = windows.map(window => beatState(progress, window));
    const active = states.reduce((best, state, index) => state.opacity >= states[best].opacity ? index : best, 0);
    const requestedBlend = smoothstep(.03, .16, progress);
    const crossingReveal = crossingHasFrame ? clamp((performance.now() - crossingRevealStarted) / 220, 0, 1) : 0;
    const blend = requestedBlend * crossingReveal;
    if (crossingReveal > 0 && crossingReveal < 1) requestRender();
    const headerHeight = document.querySelector(".site-header")?.offsetHeight || 0;
    const introExit = 1 - smoothstep(headerHeight + 16, headerHeight + Math.min(148, innerHeight * .2), moodIntroContent.getBoundingClientRect().top);
    const moodReveal = smoothstep(.84, 1, introExit);

    hero.classList.toggle("is-scrolling", progress > .025);
    hero.dataset.tone = beats[active].dataset.tone;
    hero.style.setProperty("--ambient-opacity", 1 - blend);
    hero.style.setProperty("--crossing-opacity", blend);
    hero.style.setProperty("--veil-x", veilAnchors[active][0]);
    hero.style.setProperty("--veil-y", veilAnchors[active][1]);
    hero.style.setProperty("--veil-mobile-x", veilAnchors[active][2]);
    moodIntro.style.setProperty("--mood-intro-opacity", (1 - introExit).toFixed(4));
    moodIntro.style.setProperty("--mood-intro-y", `${(-8 * introExit).toFixed(2)}px`);
    moodStage.style.setProperty("--mood-stage-reveal", moodReveal.toFixed(4));
    moodStage.style.setProperty("--mood-copy-y", `${(14 * (1 - moodReveal)).toFixed(2)}px`);

    beats.forEach((beat, index) => {
      const state = states[index];
      const visible = state.opacity > .01;
      beat.style.setProperty("--beat-opacity", state.opacity.toFixed(4));
      beat.style.setProperty("--beat-y", `${state.y.toFixed(2)}px`);
      beat.style.visibility = visible ? "visible" : "hidden";
      beat.classList.toggle("is-active", index === active && visible);
      beat.setAttribute("aria-hidden", visible ? "false" : "true");
    });

    if (crossingHasFrame && requestedBlend >= .995) ambient.pause();
    else if (ambient.hasAttribute("src") && ambient.paused) ambient.play().catch(() => {});
    if (crossing.duration && Number.isFinite(crossing.duration)) {
      const videoProgress = clamp((progress - .03) / .97, 0, 1);
      nextTime = Math.min(crossing.duration - crossingFrameDuration, Math.round((videoProgress * crossing.duration) / crossingFrameDuration) * crossingFrameDuration);
      setCrossingTime();
    }
  };

  const requestRender = () => {
    if (frameRequested) return;
    frameRequested = true;
    requestAnimationFrame(renderJourney);
  };

  const loadCrossing = () => {
    if (reduced.matches || saveData || crossingLoad || crossing.hasAttribute("src")) return;
    crossingLoad = fetch(crossing.dataset.src, { cache: "force-cache" })
      .then(response => {
        if (!response.ok) throw new Error(`Crossing video failed: ${response.status}`);
        return response.blob();
      })
      .then(blob => {
        if (reduced.matches) { crossingLoad = false; return; }
        crossingObjectUrl = URL.createObjectURL(blob);
        crossing.preload = "auto";
        crossing.src = crossingObjectUrl;
        crossing.load();
      })
      .catch(() => { crossingLoad = false; });
  };
  const loadHomeMedia = () => {
    if (reduced.matches || saveData) return;
    if (!ambient.hasAttribute("src")) { ambient.src = ambient.dataset.src; ambient.load(); ambient.play().catch(() => {}); }
  };
  const retryCrossing = () => {
    crossingHasFrame = false;
    crossingRevealStarted = 0;
    seekPending = false;
    requestRender();
    if (crossingRetries++ > 0 || reduced.matches || saveData) return;
    if (crossingObjectUrl) URL.revokeObjectURL(crossingObjectUrl);
    crossingObjectUrl = "";
    crossingLoad = false;
    crossing.removeAttribute("src");
    crossing.load();
    setTimeout(loadCrossing, 500);
  };
  crossing.addEventListener("seeked", () => {
    seekPending = false;
    const settled = Math.abs(crossing.currentTime - nextTime) <= (crossingFrameDuration / 2);
    if (settled && crossing.readyState >= 2) {
      if (!crossingHasFrame) crossingRevealStarted = performance.now();
      crossingHasFrame = true;
    }
    if (!settled) setCrossingTime();
    requestRender();
  });
  crossing.addEventListener("loadeddata", requestRender);
  crossing.addEventListener("error", retryCrossing);
  crossing.addEventListener("loadedmetadata", () => {
    if (crossing.readyState < 2) crossing.currentTime = .001;
    requestRender();
  }, { once: true });
  loadHomeMedia();
  loadCrossing();
  addEventListener("pagehide", () => crossingObjectUrl && URL.revokeObjectURL(crossingObjectUrl), { once: true });
  addEventListener("scroll", () => { loadCrossing(); requestRender(); }, { passive: true });
  addEventListener("resize", requestRender);

  const stopMoodTimer = () => { clearInterval(moodTimer); moodTimer = 0; };
  const setMood = (index, animate = true) => {
    moodIndex = (index + moodTabs.length) % moodTabs.length;
    const tab = moodTabs[moodIndex];
    const key = tab.dataset.homeMood;
    moodRoot.style.setProperty("--mood-accent", tab.dataset.color);
    moodStage.dataset.moodKey = key;
    moodStage.dataset.textTone = tab.dataset.tone;
    moodSubtitle.textContent = tab.dataset.subtitle;
    moodLine.textContent = tab.dataset.line;
    moodDescription.textContent = tab.dataset.description;
    moodLink.textContent = `Explore ${tab.textContent.trim()}`;
    moodLink.href = `/collections/${key}`;
    moodTabs.forEach((button, buttonIndex) => {
      const selected = buttonIndex === moodIndex;
      button.classList.toggle("is-active", selected);
      button.setAttribute("aria-selected", String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    moodImages.forEach(image => image.classList.toggle("is-active", image.dataset.homeMoodImage === key));
    if (animate && !reduced.matches) moodCopy.animate([{ opacity: .42, transform: "translateY(10px)" }, { opacity: 1, transform: "translateY(0)" }], { duration: 420, easing: "cubic-bezier(.23,1,.32,1)" });
    if (innerWidth <= 900) moodIndexElement.scrollTo({ left: tab.offsetLeft - ((moodIndexElement.clientWidth - tab.offsetWidth) / 2), behavior: reduced.matches ? "auto" : "smooth" });
  };
  const requestMood = (index, animate = true) => {
    const normalized = (index + moodTabs.length) % moodTabs.length;
    const image = moodImages[normalized];
    const request = ++moodRequest;
    const commit = () => request === moodRequest && setMood(normalized, animate);
    if (image.complete && image.naturalWidth) commit();
    else image.decode().then(commit).catch(() => {});
  };
  const warmMoodImages = () => Promise.allSettled(moodImages.map(image => image.decode())).then(startMoodTimer);
  const startMoodTimer = () => {
    stopMoodTimer();
    if (!moodInView || moodHovering || moodLocked || reduced.matches || document.hidden || moodImages.some(image => !image.complete || !image.naturalWidth)) return;
    moodTimer = setInterval(() => requestMood(moodIndex + 1), 3200);
  };
  if ("requestIdleCallback" in window) requestIdleCallback(warmMoodImages, { timeout: 1200 });
  else setTimeout(warmMoodImages, 500);
  moodTabs.forEach((tab, index) => {
    if (canHover) tab.addEventListener("pointerenter", () => { moodHovering = true; stopMoodTimer(); requestMood(index); });
    tab.addEventListener("click", () => { moodLocked = true; stopMoodTimer(); requestMood(index); });
    tab.addEventListener("focus", () => { moodLocked = true; stopMoodTimer(); requestMood(index); });
    tab.addEventListener("keydown", event => {
      if (!["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp", "Home", "End"].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === "Home" ? 0 : event.key === "End" ? moodTabs.length - 1 : index + (["ArrowRight", "ArrowDown"].includes(event.key) ? 1 : -1);
      const normalized = (next + moodTabs.length) % moodTabs.length;
      requestMood(normalized);
      moodTabs[normalized].focus();
    });
  });
  moodIndexElement.addEventListener("pointerleave", () => { moodHovering = false; startMoodTimer(); });
  new IntersectionObserver(entries => { moodInView = entries[0].isIntersecting; startMoodTimer(); }, { threshold: .28 }).observe(moodStage);
  document.addEventListener("visibilitychange", startMoodTimer);
  reduced.addEventListener?.("change", () => {
    if (reduced.matches) { ambient.pause(); crossing.pause(); }
    else { loadHomeMedia(); loadCrossing(); }
    startMoodTimer();
    requestRender();
  });
  setMood(0, false);
  requestRender();

  const bridge = home.querySelector("[data-surface-bridge]");
  if (bridge) {
    if (reduced.matches) bridge.classList.add("is-visible");
    else new IntersectionObserver(entries => entries.forEach(entry => entry.isIntersecting && entry.target.classList.add("is-visible")), { threshold: .28 }).observe(bridge);
  }
  }

  const reduceWorldMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const saveWorldData = navigator.connection?.saveData === true;
  const worldPosterReady = document.querySelector(".world-crossing__poster")?.decode().catch(() => {}) || Promise.resolve();
  const worldHeroVideo = document.querySelector(".world-hero__video");
  if (worldHeroVideo) {
    if (reduceWorldMotion || saveWorldData) worldHeroVideo.pause();
    else worldPosterReady.then(() => {
      worldHeroVideo.src = worldHeroVideo.dataset.src;
      worldHeroVideo.load();
      worldHeroVideo.play().catch(() => {});
      const stopHero = (_, frame = {}) => {
        if ((frame.mediaTime ?? worldHeroVideo.currentTime) >= 4.8) return worldHeroVideo.pause();
        worldHeroVideo.requestVideoFrameCallback(stopHero);
      };
      if ("requestVideoFrameCallback" in worldHeroVideo) worldHeroVideo.requestVideoFrameCallback(stopHero);
      else worldHeroVideo.addEventListener("timeupdate", () => worldHeroVideo.currentTime >= 4.8 && worldHeroVideo.pause());
    });
  }

  const worldCrossing = document.querySelector("[data-world-crossing]");
  if (worldCrossing && !reduceWorldMotion && !saveWorldData) {
    const video = worldCrossing.querySelector("[data-world-crossing-video]");
    const poster = worldCrossing.querySelector(".world-crossing__poster");
    const beats = [...worldCrossing.querySelectorAll("[data-world-beat]")];
    const centers = [.04, .27, .5, .73, .96];
    let frame = 0;
    let seekPending = false;
    let targetTime = 0;
    let crossingLoad = null;
    let crossingObjectUrl = "";
    const crossingFrameDuration = 1 / 24;
    const setTime = () => {
      if (!video.duration || !Number.isFinite(video.duration) || seekPending) return;
      if (Math.abs(video.currentTime - targetTime) <= (crossingFrameDuration / 2)) return;
      seekPending = true;
      video.currentTime = targetTime;
    };
    const render = () => {
      frame = 0;
      const travel = Math.max(1, worldCrossing.offsetHeight - innerHeight);
      const progress = Math.min(1, Math.max(0, -worldCrossing.getBoundingClientRect().top / travel));
      if (!worldCrossing.classList.contains("is-media-ready")) poster.style.transform = `scale(${(1.02 + (progress * .04)).toFixed(4)}) translate3d(0, ${(-progress * 1.5).toFixed(2)}%, 0)`;
      if (video.readyState >= 1 && Number.isFinite(video.duration)) {
        targetTime = Math.round((progress * Math.max(0, video.duration - crossingFrameDuration)) / crossingFrameDuration) * crossingFrameDuration;
        setTime();
      }
      beats.forEach((beat, index) => {
        const distance = progress - centers[index];
        const opacity = index === 0 && progress < .05 || index === beats.length - 1 && progress > .95
          ? 1
          : Math.max(0, 1 - Math.abs(distance) / .12);
        beat.style.opacity = opacity.toFixed(3);
        beat.style.setProperty("--beat-offset", `${Math.max(-28, Math.min(28, distance * -110))}px`);
      });
    };
    const queue = () => frame || (frame = requestAnimationFrame(render));
    addEventListener("scroll", queue, { passive: true });
    addEventListener("resize", queue);
    video.addEventListener("loadedmetadata", queue, { once: true });
    video.addEventListener("seeked", () => {
      seekPending = false;
      if (Math.abs(video.currentTime - targetTime) > (crossingFrameDuration / 2)) setTime();
      else if (video.readyState >= 2) worldCrossing.classList.add("is-media-ready");
    });
    video.addEventListener("error", () => worldCrossing.classList.add("is-media-fallback"));
    const loadWorldCrossing = () => {
      if (crossingLoad || video.hasAttribute("src")) return;
      crossingLoad = fetch(video.dataset.src, { cache: "force-cache" })
        .then(response => {
          if (!response.ok) throw new Error(`World crossing failed: ${response.status}`);
          return response.blob();
        })
        .then(blob => {
          crossingObjectUrl = URL.createObjectURL(blob);
          video.src = crossingObjectUrl;
          video.preload = "auto";
          video.load();
        })
        .catch(() => worldCrossing.classList.add("is-media-fallback"));
    };
    new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      loadWorldCrossing();
    }, { rootMargin: "35% 0px" }).observe(worldCrossing);
    if (worldHeroVideo?.readyState >= 2) loadWorldCrossing();
    else worldHeroVideo?.addEventListener("loadeddata", loadWorldCrossing, { once: true });
    addEventListener("pagehide", () => crossingObjectUrl && URL.revokeObjectURL(crossingObjectUrl), { once: true });
    queue();
  }

  const collection = document.querySelector("[data-collection]");
  if (collection) {
    const cards = [...collection.querySelectorAll("[data-product]")];
    const count = collection.querySelector(".result-count");
    const empty = collection.querySelector("[data-filter-empty]");
    const moodSelect = collection.querySelector("[data-mood-select]");
    let format = "all";
    let mood = "all";
    const applyFilters = () => {
      let visible = 0;
      cards.forEach(card => {
        const match = (format === "all" || card.dataset.format === format) && (mood === "all" || card.dataset.mood === mood);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (count) count.textContent = `Products shown: ${visible}`;
      if (empty) empty.hidden = visible !== 0;
      collection.querySelectorAll("[data-format-filter]").forEach(button => button.setAttribute("aria-pressed", String(button.dataset.formatFilter === format)));
    };
    collection.querySelectorAll("[data-format-filter]").forEach(button => button.addEventListener("click", () => { format = button.dataset.formatFilter; applyFilters(); }));
    moodSelect?.addEventListener("change", () => { mood = moodSelect.value; applyFilters(); });
    collection.querySelector("[data-clear-filters]")?.addEventListener("click", () => { format = "all"; mood = "all"; if (moodSelect) moodSelect.value = "all"; applyFilters(); });
  }

  document.querySelectorAll("[data-gallery]").forEach(gallery => {
    const slides = [...gallery.querySelectorAll("[data-gallery-slide]")];
    const buttons = [...gallery.querySelectorAll("[data-gallery-index]")];
    buttons.forEach(button => button.addEventListener("click", () => {
      buttons.forEach(item => item.setAttribute("aria-pressed", String(item === button)));
      slides.forEach(slide => {
        const active = slide.dataset.gallerySlide === button.dataset.galleryIndex;
        slide.hidden = !active;
        if (!active) slide.querySelectorAll("video,audio").forEach(media => media.pause());
      });
    }));
  });

  const quiz = document.querySelector("[data-mood-quiz]");
  if (quiz) {
    const moods = {
      pause: { name: "PAUSE", subtitle: "Deep Rest", line: "Less input. More open space.", description: "PAUSE is the direction of less input: spare, low-key, and unhurried.", color: "#b7a4cd" },
      hold: { name: "HOLD", subtitle: "Warm Comfort", line: "A warmer, closer sensory direction.", description: "HOLD is warm, close, and enveloping in sensory direction.", color: "#c88658" },
      rise: { name: "RISE", subtitle: "Morning Rise", line: "Clear, open, and ready to begin.", description: "RISE is clear, open, and forward-looking.", color: "#85b8c9" },
      anchor: { name: "ANCHOR", subtitle: "Grounded", line: "Composed, tactile, and considered.", description: "ANCHOR is composed, tactile, and considered.", color: "#4d776c" },
      unfold: { name: "UNFOLD", subtitle: "Tender Release", line: "A gentler edge and a quieter contrast.", description: "UNFOLD is close, quiet, and low in contrast.", color: "#c78b96" }
    };
    const order = Object.keys(moods);
    const questions = [
      ["Which space would you most like to step into?", "Choose the setting that feels most inviting right now.", [["A quiet, open room with plenty of space", "pause", "anchor"], ["A small corner with warm light and a soft throw", "hold", "unfold"], ["A bright room filled with sunlight and fresh air", "rise", "pause"], ["A calm space shaped by wood, stone, and natural texture", "anchor", "hold"], ["A softly lit room with muted colors and gentle contrast", "unfold", "hold"]]],
      ["What kind of moment are you making space for right now?", "Choose the moment that sounds closest to what you want.", [["A quiet pause with time to myself", "pause", "unfold"], ["A warm, soft moment to settle into", "hold", "anchor"], ["A fresh beginning with air and light", "rise", "anchor"], ["A familiar ritual with a steady rhythm", "anchor", "pause"], ["A gentler way to close out the day", "unfold", "pause"]]],
      ["Which materials draw you in most?", "Choose the textures and finishes you would want around the ritual.", [["Clear glass and smooth, pale surfaces", "pause", "rise"], ["Thick woven fabric and warm wood", "hold", "unfold"], ["Smooth ceramic and polished metal", "rise", "pause"], ["Textured stone and visible wood grain", "anchor", "hold"], ["Frosted glass and soft cotton", "unfold", "hold"]]],
      ["What kind of light would you want in the scene?", "Choose the lighting that makes the setting most inviting to you.", [["Even daylight spread across an open room", "pause", "rise"], ["A warm table lamp creating a small pool of light", "hold", "unfold"], ["Crisp morning light with clear highlights", "rise", "anchor"], ["Side light that brings out texture and form", "anchor", "hold"], ["Soft, diffused light with no harsh contrast", "unfold", "pause"]]],
      ["Which overall atmosphere feels closest to what you want?", "Looking at the whole scene, choose the direction that feels most complete.", [["Quiet and uncluttered, with plenty of open space", "pause", "anchor"], ["Warm and enveloping, with a sense of closeness", "hold", "unfold"], ["Fresh and bright, with the feeling of a new beginning", "rise", "pause"], ["Steady and composed, with weight and texture", "anchor", "rise"], ["Soft and low-contrast, with an unhurried pace", "unfold", "hold"]]]
    ];
    const questionMeta = [
      ["Five spaces", "Choose a space", "Space selected"],
      ["Five moments", "Choose a moment", "Moment selected"],
      ["Five material directions", "Choose materials", "Materials selected"],
      ["Five kinds of light", "Choose a kind of light", "Light selected"],
      ["Five overall directions", "Choose an overall atmosphere", "Atmosphere selected"]
    ];
    const questionStage = quiz.querySelector("[data-quiz-question-stage]");
    const journeyStage = quiz.querySelector("[data-quiz-journey-stage]");
    const position = quiz.querySelector("[data-quiz-position]");
    const title = quiz.querySelector("[data-quiz-title]");
    const helper = quiz.querySelector("[data-quiz-helper]");
    const group = quiz.querySelector("[data-quiz-group]");
    const choicesRoot = quiz.querySelector("[data-quiz-choices]");
    const status = quiz.querySelector("[data-quiz-status]");
    const continueButton = quiz.querySelector("[data-quiz-continue]");
    const backButton = quiz.querySelector("[data-quiz-back]");
    const journeyEyebrow = quiz.querySelector("[data-quiz-journey-eyebrow]");
    const journeyPosition = quiz.querySelector("[data-quiz-journey-position]");
    const journeyTitle = quiz.querySelector("[data-quiz-journey-title]");
    const journeyBody = quiz.querySelector("[data-quiz-journey-body]");
    const journeyPanel = quiz.querySelector("[data-quiz-journey-panel]");
    const live = quiz.querySelector("[data-quiz-live]");
    const scenes = [...quiz.querySelectorAll("[data-quiz-scene]")];
    const frame = quiz.querySelector(".quiz-sensory__frame");
    const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)");
    const state = { step: 0, answers: Array(5).fill(-1), scent: "", format: "", result: [] };
    let changingQuestion = false;
    let changingJourney = false;

    const setScene = index => scenes.forEach((scene, sceneIndex) => scene.classList.toggle("is-active", sceneIndex === index));
    const focusStage = target => { frame.scrollIntoView({ block: "start" }); target?.focus({ preventScroll: true }); };
    const showStage = (outgoing, incoming, focusTarget) => {
      const reveal = () => { outgoing.hidden = true; incoming.hidden = false; focusStage(focusTarget); };
      if (reduceMotion.matches || !outgoing.animate) return reveal();
      const transition = outgoing.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, easing: "ease", fill: "forwards" });
      transition.finished.then(() => { transition.cancel(); reveal(); });
    };

    const calculate = () => {
      const scores = Object.fromEntries(order.map(key => [key, 0]));
      const primary = Object.fromEntries(order.map(key => [key, 0]));
      state.answers.forEach((answer, index) => {
        const option = questions[index][2][answer];
        if (!option) return;
        scores[option[1]] += index === 4 ? 1 : 2;
        if (index !== 4) scores[option[2]] += 1;
        primary[option[1]] += 1;
      });
      return [...order].sort((a, b) => scores[b] - scores[a] || primary[b] - primary[a] || order.indexOf(a) - order.indexOf(b));
    };

    const setJourneyCopy = (eyebrow, step, heading, body) => {
      journeyEyebrow.textContent = eyebrow;
      journeyPosition.textContent = step;
      journeyTitle.textContent = heading;
      journeyBody.textContent = body;
    };
    const configureChoiceList = (name, label, description, values, selected) => `<fieldset class="quiz-sensory__configure-group quiz-sensory__configure-group--${name}"><legend>${label}</legend><p>${description}</p><div class="quiz-sensory__journey-choices">${values.map(([value, optionLabel, detail = ""]) => `<label><input type="radio" name="${name}" value="${value}"${selected === value ? " checked" : ""}><span><strong>${optionLabel}</strong>${detail ? `<small>${detail}</small>` : ""}</span></label>`).join("")}</div></fieldset>`;
    const moveQuestion = nextStep => {
      if (changingQuestion || nextStep < 0 || nextStep >= questions.length) return;
      if (reduceMotion.matches) { state.step = nextStep; renderQuestion(true); return; }
      changingQuestion = true;
      questionStage.classList.add("is-changing");
      setTimeout(() => {
        state.step = nextStep;
        renderQuestion(true);
        requestAnimationFrame(() => {
          questionStage.classList.remove("is-changing");
          changingQuestion = false;
        });
      }, 120);
    };
    const moveJourney = render => {
      if (changingJourney) return;
      if (reduceMotion.matches) return render();
      changingJourney = true;
      journeyStage.classList.add("is-changing");
      setTimeout(() => {
        render();
        requestAnimationFrame(() => {
          journeyStage.classList.remove("is-changing");
          changingJourney = false;
        });
      }, 120);
    };

    const renderQuestion = focus => {
      const [question, questionHelper, options] = questions[state.step];
      const [groupLabel, ariaLabel, selectedLabel] = questionMeta[state.step];
      const selected = state.answers[state.step];
      position.textContent = `Question ${String(state.step + 1).padStart(2, "0")} / 05`;
      title.textContent = question;
      helper.textContent = questionHelper;
      group.textContent = groupLabel;
      choicesRoot.setAttribute("aria-label", ariaLabel);
      backButton.hidden = state.step === 0;
      continueButton.hidden = selected < 0;
      continueButton.firstChild.textContent = state.step === 4 ? "See my directions " : "Continue ";
      status.textContent = selected < 0 ? "Select one answer above" : selectedLabel;
      choicesRoot.innerHTML = options.map(([label], index) => `<button class="quiz-sensory__choice${selected === index ? " is-selected" : ""}" type="button" role="radio" aria-checked="${selected === index}" data-quiz-choice="${index}" tabindex="${index === (selected >= 0 ? selected : 0) ? 0 : -1}"><span>${label}</span><i aria-hidden="true"></i></button>`).join("");
      setScene(selected >= 0 ? selected : 2);
      const choices = [...choicesRoot.querySelectorAll("[data-quiz-choice]")];
      const preview = index => { choices.forEach((choice, choiceIndex) => choice.tabIndex = choiceIndex === index ? 0 : -1); setScene(index); };
      const select = index => {
        state.answers[state.step] = index;
        choices.forEach((choice, choiceIndex) => { choice.classList.toggle("is-selected", choiceIndex === index); choice.setAttribute("aria-checked", String(choiceIndex === index)); });
        preview(index);
        status.textContent = selectedLabel;
        continueButton.hidden = false;
        live.textContent = `${options[index][0]} selected.`;
        frame.scrollIntoView({ block: "start" });
      };
      choices.forEach((choice, index) => {
        choice.addEventListener("pointerenter", () => preview(index));
        choice.addEventListener("pointerleave", () => setScene(state.answers[state.step] >= 0 ? state.answers[state.step] : 2));
        choice.addEventListener("focus", () => preview(index));
        choice.addEventListener("click", () => select(index));
      });
      if (focus) focusStage(title);
    };

    const renderConfigure = () => {
      state.result = calculate();
      const [mainKey, alternateKey] = state.result;
      const main = moods[mainKey];
      const alternate = moods[alternateKey];
      setScene(order.indexOf(mainKey));
      journeyPanel.dataset.quizView = "configure";
      setJourneyCopy("Your two closest directions", "Mood complete", `${main.name} leads. ${alternate.name} stays close.`, "These are shopping directions for this moment, not a personality type or a promised outcome.");
      const scents = [["Airy and fresh", "Airy and fresh"], ["Warm and soft", "Warm and soft"], ["Green and wooded", "Green and wooded"], ["Floral and skin-close", "Floral and skin-close"], ["No preference yet", "No preference yet"]];
      const formats = [["room", "For the room", "Scented Candle · 8oz / 226g · Review current product details"], ["body", "For the body", "Massage Oil Candle · 4oz / 113g · Review current product details"], ["both", "Both Formats", "Compare both Formats in your main Mood"]];
      journeyPanel.innerHTML = `<div class="quiz-sensory__journey-inner"><div class="quiz-sensory__directions"><article style="--mood:${main.color}"><span>Best fit from five answers</span><strong>${main.name}</strong><p>${main.line}</p></article><article style="--mood:${alternate.color}"><span>Also explore</span><strong>${alternate.name}</strong><p>${alternate.line}</p></article></div><form class="quiz-sensory__configure" data-quiz-configure><div class="quiz-sensory__configure-grid">${configureChoiceList("scent", "Scent preference", "Choose what you usually reach for. Confirm the actual scent on the product page.", scents, state.scent)}${configureChoiceList("format", "Where should the ritual live?", "Choose the room, the body, or compare both.", formats, state.format)}</div><p class="quiz-sensory__error" role="alert" tabindex="-1" hidden>Choose both a scent preference and a Ritual.</p><div class="quiz-sensory__journey-actions"><button class="quiz-sensory__continue" type="submit" data-quiz-result${state.scent && state.format ? "" : " disabled"}>Show matching products <span aria-hidden="true">→</span></button><button class="quiz-sensory__text-button" type="button" data-quiz-back-questions>Back to the last question</button></div></form></div>`;
      const form = journeyPanel.querySelector("[data-quiz-configure]");
      const next = journeyPanel.querySelector("[data-quiz-result]");
      form.addEventListener("change", event => {
        if (event.target.name === "scent") state.scent = event.target.value;
        if (event.target.name === "format") state.format = event.target.value;
        next.disabled = !(state.scent && state.format);
      });
      form.addEventListener("submit", event => {
        event.preventDefault();
        if (!(state.scent && state.format)) { const error = journeyPanel.querySelector(".quiz-sensory__error"); error.hidden = false; error.focus(); return; }
        moveJourney(renderResult);
      });
      journeyPanel.querySelector("[data-quiz-back-questions]").addEventListener("click", () => { state.step = 4; renderQuestion(false); showStage(journeyStage, questionStage, title); });
      focusStage(journeyTitle);
    };

    const renderResult = () => {
      const [mainKey, alternateKey] = state.result;
      const main = moods[mainKey];
      const alternate = moods[alternateKey];
      const handles = state.format === "both" ? [`${mainKey}-room`, `${mainKey}-body`] : [`${mainKey}-${state.format}`];
      const cards = handles.map(handle => quiz.querySelector(`[data-quiz-product-template="${handle}"]`)?.innerHTML || "").join("");
      setScene(order.indexOf(mainKey));
      journeyPanel.dataset.quizView = "result";
      setJourneyCopy("Your ritual", "Complete", main.name, main.description);
      journeyPanel.innerHTML = `<div class="quiz-sensory__journey-inner quiz-sensory__journey-inner--result"><div class="quiz-sensory__match-head"><p><span>Also explore</span><strong>${alternate.name}</strong></p><p><span>Your scent preference</span><strong>${state.scent}</strong></p></div><div class="quiz-sensory__recommendations product-grid${handles.length === 1 ? " is-single" : ""}">${cards}</div><p class="quiz-sensory__match-note">Your Mood and Ritual determine these product directions. Confirm the current scent details on the product page before choosing.</p><div class="quiz-sensory__journey-actions"><button class="quiz-sensory__secondary" type="button" data-quiz-adjust>Adjust scent or Ritual</button><a class="quiz-sensory__secondary" href="/collections/${alternateKey}">Explore ${alternate.name}</a><button class="quiz-sensory__text-button" type="button" data-quiz-retake>Retake the Quiz</button></div></div>`;
      journeyPanel.querySelector("[data-quiz-adjust]").addEventListener("click", () => moveJourney(renderConfigure));
      journeyPanel.querySelector("[data-quiz-retake]").addEventListener("click", () => { state.step = 0; state.answers.fill(-1); state.scent = ""; state.format = ""; state.result = []; renderQuestion(false); showStage(journeyStage, questionStage, title); });
      focusStage(journeyTitle);
    };

    choicesRoot.addEventListener("keydown", event => {
      const choices = [...choicesRoot.querySelectorAll("[data-quiz-choice]")];
      if (!choices.length || !["ArrowDown", "ArrowRight", "ArrowUp", "ArrowLeft", "Home", "End"].includes(event.key)) return;
      event.preventDefault();
      const current = Math.max(0, choices.indexOf(document.activeElement));
      const next = event.key === "Home" ? 0 : event.key === "End" ? choices.length - 1 : ["ArrowDown", "ArrowRight"].includes(event.key) ? (current + 1) % choices.length : (current - 1 + choices.length) % choices.length;
      choices[next].focus();
    });
    continueButton.addEventListener("click", () => {
      if (state.answers[state.step] < 0) return;
      const nextUnanswered = state.answers.findIndex((answer, index) => index > state.step && answer < 0);
      const firstUnanswered = nextUnanswered >= 0 ? nextUnanswered : state.answers.findIndex(answer => answer < 0);
      if (firstUnanswered >= 0) moveQuestion(firstUnanswered);
      else { renderConfigure(); showStage(questionStage, journeyStage, journeyTitle); }
    });
    backButton.addEventListener("click", () => moveQuestion(state.step - 1));
    renderQuestion(false);
  }

  const privacyControls = () => document.querySelectorAll("[data-privacy-preferences]");
  const setPrivacyControlsAvailable = available => privacyControls().forEach(control => {
    control.disabled = !available;
    control.hidden = !available && !control.querySelector("[data-privacy-state]");
    control.querySelector("[data-privacy-state]")?.replaceChildren(available ? "Available" : "Not available yet");
    if (control.dataset.privacyBound) return;
    control.dataset.privacyBound = "true";
    control.addEventListener("click", () => {
      try {
        Promise.resolve(window.privacyBanner.showPreferences()).catch(() => setPrivacyControlsAvailable(false));
      } catch {
        setPrivacyControlsAvailable(false);
      }
    });
  });
  const initPrivacyControls = () => {
    if (typeof window.privacyBanner?.showPreferences === "function") setPrivacyControlsAvailable(true);
  };
  initPrivacyControls();
  window.addEventListener("load", initPrivacyControls);
  document.addEventListener("shopifyCustomerPrivacyApiLoaded", initPrivacyControls);
})();
